import React, {ReactElement} from 'react';
import {daysBetween, getTodayStartTime} from 'shared/utils/dateTime';
import {inclineDays} from 'shared/utils/incline';
import {toReadable} from 'shared/utils/number';

import {useFutureBudgetAmount} from 'ui/utils/core';
import {useBudgetStore} from 'store/Budget';
import {openSettings} from 'store/UI';
import {updateMode, InputMode} from 'store/UserInput';
import {useDispatch} from 'ui/store';

import Settings from 'assets/settings.svg';
import {Button} from 'components/Button';
import {Icon} from './style';
import {compose} from 'shared/utils/compose';

export const SettingsButton = (): ReactElement => {
  const openSettingsHandler = useDispatch(openSettings);
  const updateInputMode = useDispatch(updateMode, InputMode.Spend);

  const {finishDate} = useBudgetStore();
  const moneyLeft = useFutureBudgetAmount();

  const daysCount = Math.max(daysBetween(finishDate, getTodayStartTime()), 0);
  const daysLabel = inclineDays(daysCount);

  return (
    <Button onPress={compose(openSettingsHandler, updateInputMode)} data-test='settings-btn'>
      {toReadable(moneyLeft)} на {daysCount} {daysLabel}
      <Icon src={Settings} alt='Settings icon' />
    </Button>
  );
};
